module.exports = __webpack_public_path__ + "static/media/LPOneAndPhotos.b31a9367.jpg";